<script>
import SectionTitle from '@components/section-title'
import con from '@services/connection'
import { cadastroProfissional } from '@constants/URL'
import Vue from 'vue'
import { MODAL, RELOAD } from '@constants/Text'
import rules from '@constants/Rules'
import { GlobalBus } from '@services/bus'

export default {
  components: {
    SectionTitle,
  },
  props: {
    bus: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      busModal: new Vue(),
      professionals: '',
      rules: rules,
      formValid: false,
      loading: false,
    }
  },
  created() {
    if (this.bus) {
      this.bus.$on(MODAL.REGISTER_PROFESSIONAL, this.open)
    }

    GlobalBus.$on(MODAL.REGISTER_PROFESSIONAL, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.REGISTER_PROFESSIONAL, this.open)
  },
  methods: {
    open(v) {
      this.clearData()
      this.busModal.$emit('dialog', v)
    },
    sendData(close) {
      if (this.loading) {
        return
      }
      if (!this.$refs.form.validate()) {
        return
      }

      this.loading = true
      let professionals = this.professionals.split(';')

      con
        .post(cadastroProfissional.register_professionals, {
          team_list: JSON.stringify(professionals),
        })
        .then((res) => {
          if (res && res.status == 200) {
            this.$showSnack({
              text: 'Profissionais cadastrados com sucesso',
              button: true,
            })
            close()
            GlobalBus.$emit(RELOAD.PROFESSIONALS)
          } else {
            this.$showSnack({
              text: res.message,
              button: true,
            })
          }
          this.loading = false
        })
    },
    clearData() {
      this.professionals = ''
      this.formValid = false
      this.loading = false
    },
  },
}
</script>

<template>
  <BaseModal max-width="900px" height="600px" :bus="busModal" persistent>
    <SectionTitle title="Cadastro de profissionais" />
    <v-form ref="form" v-model="formValid">
      <v-textarea
        v-model="professionals"
        required
        :rules="[rules.emails]"
        label="Cadastre o email dos seus profissionais"
        placeholder="email1@email.com;email2@email.com;email3@email.com"
        style="margin-top: 20px"
      />
    </v-form>
    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close">
        Cancelar
      </BaseButton>
      <BaseButton primary :loading="loading" @click="sendData(close)">
        Cadastrar
      </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>


